<template>
  <div class="content">
    <div class="head">
      <div class="income">
        <div class="date">
          <div class="time">{{date}}</div>
          <div class="time-icon"><span>所属教练：{{owner_name}}</span></div>
        </div>
        <div class="total-amount">
          <span style="opacity: 0.5">收入金额：</span>
          <span>{{total_amount}}</span>
          <span style="opacity: 0.5">设备编号：{{soft_sn}}</span>
        </div>
      </div>
    </div>
    <div class="income-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
      <div class="income-item" v-for="(income, index) in incomeList" :key="index" @click="toParticulars(income)">
        <order-item :time="income.created_at" :price="'+' + income.amount"></order-item>
      </div>
    </div>
  </div>
</template>
<script>
import orderItem from '@/components/order_item'
import { income } from '@/http/api'
import infiniteScroll from 'vue-infinite-scroll';
import Vue from 'vue';
Vue.use(infiniteScroll)
export default {
  data () {
    return {
      soft_sn: '',
      owner_name: '',
      total_amount: '',
      ym: '',
      public_path: process.env.PUBLICK_PATH,
      price: '',
      date: '',
      state_cn: '',
      total_current_month: 0,
      incomeList: [],
      values: [],
      page: 1,
      total_page: 0
    }
  },
  methods: {
    toParticulars (income) {
      this.$router.push({
        name: 'Incomeparticulars',
        params: {
          income: income
        }
      })
    },

    loadMore () {
      this.page += 1
      this.income()
    },

    income () {
      let data = {
        token: localStorage.token,
        soft_sn: this.soft_sn,
        ym: this.ym,
        page: this.page,
        limit: 20
      }
      income(data).then(res => {
        console.log(res)
        this.owner_name = res.data.owner_name
        this.soft_sn = res.data.soft_sn
        this.total_amount = (res.data.total_amount).toFixed(2)
        this.incomeList = this.incomeList.concat(res.data.data)
      })
    }
  },

  mounted () {
    this.soft_sn = this.$route.query.softsn
    this.ym = this.$route.query.ym
    this.date = this.ym.slice(0, 4) + '年' + this.ym.slice(-2) + '月'
    console.log(this.date)
    this.income()
  },

  components: {
    'order-item': orderItem
  }
}
</script>
<style lang="scss" scoped>
.content {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  font-size: 0;
  color: #333;
  background: #f5f5f5;
  font-size: 0;
  >.head {
    background: #fff;
    padding: .26rem .3rem;
    .date {
      display: -webkit-flex;
      display: flex;
      .time {
        font-size: .32rem;
        color: #02B389;
        flex: 1;
        text-align: left;
      }
      .time-icon {
        flex: 1;
        text-align: right;
        span {
          font-size: .26rem;
          color: rgba(0, 0, 0, .5);
        }
      }
    }
    .total-amount {
      margin-top: .22rem;
      display: flex;
      display: -webkit-flex;
      span {
        color: #000;
        font-size: .28rem;
        &:nth-child(3) {
          flex: 1;
          text-align: right;
        }
      }
    }
  }
  .income-list {
    margin-top: .2rem;
  }
  .picker-bg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
  }
  .pciker-time {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: #fff;
    .head {
      height: 1rem;
      line-height: 1rem;
      display: -webkit-flex;
      display: flex;
      padding: 0 .3rem;
      border-bottom: 1px solid #EBEBEB;
      .clear {
        flex: 1;
        font-size: .26rem;
        text-align: left;
        color: rgba(51, 51, 51, .6);
      }
      .title {
        flex: 1;
        font-size: .32rem;
        text-align: center;
      }
      .sure {
        flex: 1;
        text-align: right;
        font-size: .26rem;
        color: #02B389;
      }
    }
    .time-value {
      height: .88rem;
      line-height: .88rem;
      padding: 0 .3rem;
      span {
        width: 100%;
        text-align: center;
        font-size: .28rem;
        color: #02B389;
        display: inline-block;
        border-bottom: 1px solid #02B389;
      }
    }
    .pic {
      padding: .3rem 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/incomedetail/Incomedetail.vue